// extracted by mini-css-extract-plugin
export var blog_img = "index-module--blog_img--IGb3+";
export var blog_list = "index-module--blog_list--IwxCz";
export var blog_list_container = "index-module--blog_list_container--xI8hi";
export var blog_text = "index-module--blog_text--vjZiJ";
export var category = "index-module--category--0zV10";
export var date = "index-module--date--k5fqa";
export var date_category = "index-module--date_category--u6suS";